export const version = "2.0-beta (0.10.4-243-g839860ad)";
